import React from 'react';
import { StarIcon as StarSolidIcon } from '@heroicons/react/24/solid';

const ReviewCard = ({ name, headline, rating, comment, commentClassName }) => {
  const formatFaNumber = (value) => {
    return new Intl.NumberFormat('fa-IR').format(value);
  };

  const renderStars = (rating, className = 'h-4 w-4') => {
    return (
      <div className="flex">
        {[...Array(5)].map((_, i) => (
          <StarSolidIcon 
            key={i} 
            className={`${className} ${i < rating ? 'text-yellow-400' : 'text-gray-300'}`} 
          />
        ))}
      </div>
    );
  };

  return (
    <div className="shrink-0 w-[280px] sm:w-[320px] bg-[#FCECD5] rounded-3xl shadow-lg border border-[#F3D7B1] p-6 snap-center transition-transform hover:-translate-y-1 duration-300">
      <div className="min-w-0 font-bold text-gray-900 truncate mb-2">{name}</div>
      <div className="flex items-center justify-between gap-3 mb-3">
        <div className="min-w-0 font-bold text-gray-900 text-[15px] line-clamp-1">{headline || '—'}</div>
        <div className="flex items-center gap-2 shrink-0">
          <div className="text-sm font-semibold text-gray-800">{formatFaNumber(rating)} از ۵</div>
          <div className="flex items-center">{renderStars(rating, 'h-4 w-4')}</div>
        </div>
      </div>
      <div className={`text-gray-800 text-[14px] leading-relaxed text-justify line-clamp-5 ${commentClassName || ''}`.trim()}>
        {comment || '—'}
      </div>
    </div>
  );
};

export default ReviewCard;
